import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63050794"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "container-custom" }
const _hoisted_4 = { class: "nav__body body" }
const _hoisted_5 = { class: "body__logo" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", { class: "img img-brand" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "body__nav navigation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_BgBar = _resolveComponent("BgBar")!
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name: 'Home'}))),
              class: "brand"
            }, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Navigation, { class: "navigation__wrapp desctop" }),
            _createVNode(_component_BgBar, {
              value: _ctx.activeBg,
              class: "mobile"
            }, null, 8, ["value"]),
            _createVNode(_component_Btn, {
              onActiveBgMenu: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeBg = !_ctx.activeBg))
            })
          ])
        ])
      ])
    ])
  ]))
}